import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';
import {VayuBlockAdvanceStyle} from '@vayu-blocks/advance-panel/style.js';
import { getSvgMaskBase64 } from '@vayu-blocks/animation/maskstyle.js';
import {borderRadiusStyle} from '@vayu-blocks/global';
import { VayuBlocksDevice } from '@vayu-blocks/device-control';

export default function AdvanceSettings({ children, attributes,clientId, framestyles}) {
    const getView = VayuBlocksDevice();

    const { mergedStyles, handleMouseEnter, handleMouseLeave, hoverAnimationClass} = VayuBlockAdvanceStyle(attributes);
   
    const imagePath = getSvgMaskBase64(attributes.animationData.mask.maskshape);  

    const overlayhvrcolor = attributes.overlayshow? attributes.overlayhvrcolor || attributes.overlaycolor || '': '';

    let opacity = (attributes.showPreview || attributes.overlay) ? 1 : 0;

    const frameVariables = Object.entries(framestyles).reduce((acc, [key, value]) => {
        if (
            key === "borderTopWidth" ||
            key === "borderRightWidth" ||
            key === "borderBottomWidth" ||
            key === "borderLeftWidth"
        ) {
            const side = key
                .replace("border", "")     // "TopWidth"
                .replace("Width", "")      // "Top"
                .toLowerCase();            // "top"

            acc[`--wrapper-image-border-${side}`] = `${value} solid`;
        } else {
            // Default conversion for all other props
            const cssVar = `--wrapper-image-${key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}`;
            acc[cssVar] = value;
        }

        return acc;
    }, {});

    const customStyle = {
        ...mergedStyles,
        ...frameVariables,
        
        ...(attributes.position?.width?.Desktop && { '--border-frame-width-dekstop': `${attributes.position?.width?.Desktop}`}),
        ...(attributes.position?.width?.Tablet && { '--border-frame-width-tablet': `${attributes.position?.width?.Tablet}`}),
        ...(attributes.position?.width?.Mobile && { '--border-frame-width-mobile': `${attributes.position?.width?.Mobile}`}),
        ...(attributes.position?.height?.Desktop && { '--border-frame-height-dekstop': `${attributes.position?.height?.Desktop}`}),
        ...(attributes.position?.height?.Tablet && { '--border-frame-height-tablet': `${attributes.position?.height?.Tablet}`}),
        ...(attributes.position?.height?.Mobile && { '--border-frame-height-mobile': `${attributes.position?.height?.Mobile}`}),
        ...(attributes.position?.top?.Desktop && { '--border-frame-top-dekstop': `${attributes.position?.top?.Desktop}`}),
        ...(attributes.position?.top?.Tablet && { '--border-frame-top-tablet': `${attributes.position?.top?.Tablet}`}),
        ...(attributes.position?.top?.Mobile && { '--border-frame-top-mobile': `${attributes.position?.top?.Mobile}`}),
        ...(attributes.position?.left?.Desktop && { '--border-frame-left-dekstop': `${attributes.position?.left?.Desktop}`}),
        ...(attributes.position?.left?.Tablet && { '--border-frame-left-tablet': `${attributes.position?.left?.Tablet}`}),
        ...(attributes.position?.left?.Mobile && { '--border-frame-left-mobile': `${attributes.position?.left?.Mobile}`}),

        ...(attributes?.animationData?.imageAnimation?.speed && { '--image-animation-spped': `${attributes.animationData?.imageAnimation?.speed}s` }),
        ...(attributes?.animationData?.hovereffect?.value && {'--image-hover-effect': `${attributes.animationData.hovereffect.value}`,}),
        ...(attributes?.imagehvrfilter && {'--image-filter-effect': `${attributes.imagehvrfilter}`,}),
        ...(attributes?.mageoverlayouteffect && {'--overlay-effect': `${attributes.mageoverlayouteffect}`,}),
        ...(attributes?.overlaytransitiontime != null && {'--overlay-transitiontime': `${attributes.overlaytransitiontime}s`,}),
        ...(attributes?.imagetransitiontime != null && {'--image-transitiontime': `${attributes.imagetransitiontime}s`,}),
        ...(opacity != null && {'--overlay-opacity': `${opacity}`,}),
        ...(attributes?.buttonhvrbackground && {'--button-hvr-background': `${attributes.buttonhvrbackground}`,}),
        ...(attributes?.buttonhvrcolor && {'--button-hvr-color': `${attributes.buttonhvrcolor}`,}),
        ...(attributes?.imageborderRadius && attributes.imageborderRadius.top != null && {'--overlay-border-radius': `${attributes.imageborderRadius.top} ${attributes.imageborderRadius.right} ${attributes.imageborderRadius.bottom} ${attributes.imageborderRadius.left}`,}),
        ...(attributes?.animationData?.mask?.masksize && {'--image-url-size': `${attributes.animationData.mask.masksize}`,}),
        ...(attributes?.animationData?.mask?.maskposition && {'--image-url-position': `${attributes.animationData.mask.maskposition}`,}),
        ...(attributes?.animationData?.mask?.maskrepeat && {'--image-url-repeat': `${attributes.animationData.mask.maskrepeat}`,}),
        ...(imagePath && {'--image-url-shape': `url(${imagePath})`,}),
        ...(overlayhvrcolor && {'--overlay-hvr-color': `${overlayhvrcolor}`,}),
        ...(attributes?.rotation != null && {'--image-transform': `${attributes.rotation}deg`,}),
        ...(attributes?.animationData?.effect?.effectColor && {'--wrapper-effect3-color': `${attributes.animationData.effect.effectColor}`,}),
        ...(attributes?.overlayopacity != null && {'--wrapper-overlay-opacity': attributes.overlayopacity,'--wrapper-overlay-hover-opacity': attributes.overlayopacity,}),
        ...(attributes?.captionalignment && {'--wrapper-image-caption-alignment': attributes.captionalignment,}),
        ...(attributes?.captionalignmentTablet && {'--wrapper-image-caption-alignment-tablet': attributes.captionalignmentTablet,}),
        ...(attributes?.captionalignmentMobile && {'--wrapper-image-caption-alignment-mobile': attributes.captionalignmentMobile,}),
        ...(attributes?.frameData?.radius && {'--overlay-border-radius': borderRadiusStyle(attributes.frameData.radius, getView),}),
        ...(attributes?.overlayalignment && attributes.overlayalignment.includes(' ') && {'--h-text-align': attributes.overlayalignment.split(' ')[1],}),
    };

    const blockProps = useBlockProps({
        className: `block-${clientId} ${hoverAnimationClass} ${['screenfit', 'custom'].includes(attributes.screenfit) ? 'alignfull' : ''}`,
        style: customStyle,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
    });

    return (
        <div {...blockProps}>
            {children}
        </div>
    );
}